import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Row, Col } from "react-bootstrap";
import { createPageInElement } from "../../api/api";
import toastr from "toastr";
import "toastr/build/toastr.min.css";

const PageModal = (props) => {
  const handlePage = async (event, type) => {
    // const redirect = type==="normalPage"?"/page/":"/"+type.toLowerCase()+"/";
    event.preventDefault();
    const page = {
      pageType: type,
      referenceName: "UnNamed " + type,
      items: [],
    };
    /* eslint-disable no-unused-vars */
    const result = await createPageInElement(page, props.url).then(
      (result) => {
        toastr.success("Successfully Created New Page", "Success");
        // props.history.push(redirect+result.data._id);
      },
      (error) => {
        toastr.error(error.response.data.error.message, "Error");
      }
    );
    /* eslint-disable no-unused-vars */
  };

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter">Pages</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col sm="4">
            <a href="#!" onClick={(event) => handlePage(event, "normalPage")}>
              Normal Page
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handlePage(event, "seasonPage")}>
              Season Page
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handlePage(event, "articlePage")}>
              Article Page
            </a>
          </Col>
        </Row>
        <Row>
          <Col sm="4">
            <a href="#!" onClick={(event) => handlePage(event, "internalPage")}>
              Internal Page
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handlePage(event, "externalPage")}>
              External Page
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handlePage(event, "videoPage")}>
              Video Page
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handlePage(event, "livePage")}>
              Live Page
            </a>
          </Col>
          <Col sm="4">
            <a href="#!" onClick={(event) => handlePage(event, "textPage")}>
              Text Page
            </a>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};
export default PageModal;
